var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (['h1', 'h2', 'h3', 'h4', 'h5'].includes(_vm.textStyle))?_c(_vm.textStyle,{tag:"component"},[_vm._t("default")],2):_c('p',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }